import { useEffect, useRef, useState } from "react";
import { Popup } from "@/components/common/Popup";
import {  TextChatInfoSchema } from "./TextChatSchema";
import {  TextChatInfo } from "./TextChatInfo";
import {   Trash2 } from "lucide-react";
import {Plus} from "lucide-react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  apiFetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;
  eventId: string ;
  onError?: (message: string) => void;
};



export function TextChatSetupPopup({ isOpen, onClose, apiFetch, eventId,  onError }: Props) {
  const [chats, setChats] = useState<TextChatInfoSchema[]>([]);
  const [loading, setLoading] = useState(false);
  const [editChat, setEditChat] = useState<TextChatInfoSchema | null>(null);
  const wasOpenRef = useRef(false);

  const closeEdit = () => {
    if(editChat)
    setEditChat(null);
  else
    onClose();
  };

  const onChatClosed = (refresh: boolean) => {
    setEditChat(null);
    if (!refresh) return;

//replace title date and tabname of the chat in the list
    loadChats();
  }
  

 
  const deleteChat = async (id :number) => {
    const usersRes = await apiFetch(`/api/EventPool/DeleteChatRoom?key=${id}`, {
      method: "DELETE",
    });
    if (!usersRes.ok) {
      if(onError)
      onError("Failed to delete chat");
    }

    setChats((prev) => prev.filter((u) => u.Id !== id));
  }

 const loadChats = async () => {
      try {
        setLoading(true);

        
        const res = await apiFetch(`/api/EventPool/GetChatRooms?eventId=${eventId}`);
        if (!res.ok) {
          setChats([]);
          return;
        }

        const data = await res.json();
       

        setChats(data );

      } catch (err) {
        console.error(err);
        
          setChats([]);
          onError?.("Failed to load chats");
        
      } finally {
         setLoading(false);
      }
    };

  useEffect(() => {
    const openedNow = isOpen && !wasOpenRef.current;
    if (openedNow) {
      console.log("Loading chats for event", eventId);
      loadChats();
    }

    wasOpenRef.current = isOpen;
  }, [isOpen, eventId]);

  return (
    <Popup isOpen={isOpen} onClose={closeEdit} title={editChat != null ? " Chat" : "Chats"} className="w-[95vw] max-w-6xl">
      {editChat == null && (
      <div className="overflow-x-auto">
        <div className="float-right cursor-pointer mb-5"><Plus onClick={() => setEditChat({} as TextChatInfoSchema)}></Plus></div>
        <table className="min-w-full text-sm">
          <thead className="bg-slate-100 text-left">
            <tr>
              <th className="px-3 py-2 w-[100px]">Id</th>
              <th className="px-3 py-2 w-[200px]">Name</th>
              <th className="px-3 py-2 w-[200px]">Access Code</th>
              <th className="px-3 py-2 w-[150px]">Link</th>
              <th className="px-3 py-2 w-[100px]">Closed</th>
              <th className="px-3 py-2 w-[100px]">Alone</th>
              <th className="px-3 py-2 w-[100px]">Incognito Allowed</th>
              <th className="px-3 py-2 w-[100px]">Upload Allowed</th>
              <th className="px-3 py-2 w-[100px]"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="border-t">
                <td colSpan={8} className="px-3 py-4 text-center text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : (!chats || chats.length === 0 )? (
              <tr className="border-t">
                <td colSpan={8} className="px-3 py-4 text-center text-gray-500">
                  No chats yet
                </td>
              </tr>
            ) : (
              chats.map((item, index) => (
                <tr
                  key={`${item.Id ?? "chat"}-${index}`}
                  className={`border-t align-middle `}
                  onClick={() => {
                   
                    setEditChat(item);
                  }}
                 
                  style={{ cursor: "pointer" }}
                >
                 
                  <td className="px-3 py-2">{item.Id ?? ""}</td>
                  <td className="px-3 py-2">{item.Name ?? ""}</td>
                  <td className="px-3 py-2">{item.AccessCode ?? ""}</td>
                  <td className="px-3 py-2"><a className="text-blue-500" href={item.Link ?? "#"} target="_blank" rel="noopener noreferrer">Moderator Link</a></td>
                  <td className="px-3 py-2">{item.Closed ? "Yes" : "No"}</td>
                  <td className="px-3 py-2">{item.Alone ? "Yes" : "No"}</td>
                  <td className="px-3 py-2">{item.IncognitoAllowed ? "Yes" : "No"}</td>
                  <td className="px-3 py-2">{item.UploadAllowed ? "Yes" : "No"}</td>
                  <td className="px-3 py-2 text-right text-gray-500">
               <Trash2 onClick={(e) => {
                 e.stopPropagation();
                    if(!item.Id) return;
                    if(!confirm("Are you sure you want to delete this chat?")) return;
                    deleteChat(item.Id);
                  }}></Trash2>
                  </td>
                </tr>
       
              ))
            )}
          </tbody>
        </table>
      </div>)}

      {editChat != null && (
        <div>
          <TextChatInfo  chat={editChat} eventId={eventId} onClose={(chat) => onChatClosed(chat)} onError={(message) => onError && onError(message)} />
        </div>
      )}
    </Popup>
  );
}
